import React from 'react'
import { Skeleton } from 'antd'
import { SectionError } from '../../components/section-error'
import { SectionWell } from '../../components/section-well'
import { HeadlineTile } from './headline-model'
import { KpiTile } from './kpi-tile'

type Props = {
    status: 'loading' | 'ready' | 'error'
    tiles: HeadlineTile[]
    onRetry: () => void
}

const TILE_COUNT = 5

export const HeadlineSection: React.FC<Props> = ({ status, tiles, onRetry }) => (
    <SectionWell sectionKey="headline" title="Headline" ghost>
        {status === 'error' ? (
            <SectionError sectionName="Headline" onRetry={onRetry} />
        ) : (
            <div
                className="org-dashboard-headline-grid"
                aria-busy={status === 'loading'}
                // Tiles the definitions withhold leave no gap: the grid divides the row among those that remain.
                style={
                    status === 'ready' && tiles.length > 0
                        ? ({ '--org-dashboard-headline-tile-count': tiles.length } as React.CSSProperties)
                        : undefined
                }
            >
                {status === 'loading'
                    ? Array.from({ length: TILE_COUNT }, (_, index) => (
                          <div className="org-dashboard-kpi-tile-skeleton" key={index} aria-busy="true">
                              <Skeleton.Input active size="small" style={{ width: 80 }} />
                              <div className="org-dashboard-kpi-tile-skeleton-value-row">
                                  <Skeleton.Input active size="large" style={{ width: 96 }} />
                                  <Skeleton.Input active size="small" style={{ width: 44 }} />
                              </div>
                              <Skeleton.Input active size="small" style={{ width: '70%' }} />
                              <Skeleton.Node active className="org-dashboard-kpi-tile-skeleton-sparkline">
                                  <span />
                              </Skeleton.Node>
                              <Skeleton.Input active size="small" style={{ width: '55%' }} />
                          </div>
                      ))
                    : tiles.map((tile) => <KpiTile key={tile.key} tile={tile} />)}
            </div>
        )}
    </SectionWell>
)
